import { throttle } from 'lodash-es';

const $filter = document.querySelector('.case-studies-filter');
const $filterList = $filter.querySelector('.case-studies-filter__list');

if ($filter && $filterList) {
  const updateScrollClasses = () => {
    const { scrollLeft } = $filterList;
    const maxScrollLeft = $filterList.scrollWidth - $filterList.clientWidth;

    $filter.classList.toggle('scrolled-from-start', scrollLeft > 0);
    $filter.classList.toggle('scrolled-to-end', scrollLeft >= maxScrollLeft);
  };

  updateScrollClasses();

  $filterList.addEventListener(
    'scroll',
    throttle(() => updateScrollClasses(), 250)
  );

  globalThis.addEventListener(
    'resize',
    throttle(() => updateScrollClasses(), 250)
  );
}
